module.exports = __webpack_public_path__ + "static/media/background.58f249c1.jpg";